export const MEMOIZE_DUMMY_RESOLVER = (...args) => args[0];
export const MEMOIZE_SESSION_TIMEOUT = 1000 * 60 * 5;
export const ETH_NULL_ADDRESS = '0x0000000000000000000000000000000000000000';
export const ZERO_ALLOWANCE_ASSETS = ['USDT', 'ANTv1', 'BNT', 'SNT', 'MANA', 'DENT', 'LDO'];
export const ALLOWED_AMOUNTS_DIFF_PERCENTAGE = 10;
export const LOGS = Object.freeze({
    APPROVING_TOKENS: 'Approving tokens',
    BROADCASTING_TX: 'Broadcasting raw tx',
    CHECKING_ALLOWANCE: 'Checking allowance',
    CHECKING_ORDER_VALIDITY: 'Checking order validity',
    CREATING_ORDER: 'Creating order in the exchange-server',
    CREATING_TX: 'Creating TX',
    DECODING_TX: 'Decoding transaction',
    FAILED_TO_APPROVE_TOKENS: 'Failed to approve tokens',
    FAILED_TO_CREATE_ORDER: 'Failed to create order',
    FAILED_TO_CREATE_TX: 'Failed to create transaction',
    FAILED_TO_GET_ALLOWANCE: 'Failed to get allowance',
    FAILED_TO_GET_TX: 'Failed to get tx',
    FAILED_TO_SEND_TX: 'Failed to send tx',
    FAILED_TO_SIGN_TX: 'Failed to sign tx',
    FAILED_TO_UPDATE_BLOCKHASH: 'Soft error: failed to update blockhash',
    FAILED_TO_VALIDATE_ORDER: 'Failed to validate order',
    GETTING_PROVIDER_ORDER: 'Getting provider order',
    GETTING_TX: 'Getting tx from provider',
    REVOKING_ALLOWANCE: 'Revoking allowance',
    SENDING_TX: 'Sending TX',
    SIGNING_TX: 'Signing raw tx',
    UPDATING_ORDER: 'Updating order with txId',
    JUPITER_SIMULATION_FAILED: 'Jupiter simulation failed',
    SIMULATION_FAILED: 'Simulation failed',
    SIMULATING_TX: 'Simulating Tx',
});
